<script>
    import FrameworkReference from '../../Models/frameworkReferenceModel';
    import {engine} from '../../lib/liquid_engine';
    import Fa from 'svelte-fa';
    import { faSearch } from '@fortawesome/free-solid-svg-icons';

    import {addModal} from '../../Components/ModalManager.svelte';
    import FrameworkSearchModal from '../../Components/FrameworkReference/FrameworkSearchModal.svelte';
    import ReferenceModal from '../../Components/FrameworkReference/ReferenceModal.svelte';
    import { sortBy } from 'lodash-es';

    import {notifier} from "@beyonk/svelte-notifications";

    import {db} from '../../Database.svelte';

    export let name;
    export let value = [];
    export let readOnly = false;

    let mouseover = false;

    let currentFramework;
    let currentReference;
    let frameworkItems = [];

    async function loadFrameworkItems(selected_framework) {
        if(!selected_framework) return

        let framework = (await FrameworkReference.getStatic(selected_framework._id));

        let tpl = selected_framework.autocomplete || '{{data["name"]}}';

        frameworkItems = await Promise.all([...framework.references].map(async (f) => {
            let label = await engine.parseAndRender(tpl, {data: f.details});

            return {
                label,
                value: f.details
            }
        }));
    }

    function addReference(framework, reference) {
        // prevent duplicate reference
        for (let item of value) {
            if (item.reference_id == reference._id) {
                notifier.danger("Cannot Add Duplicate Reference");
                return;
            }
        }

        value = [...value, {
            framework: framework.name,
            control: reference.name,
            reference_id: reference._id
        }]
    }

    function removeReference(reference) {
        value = value.filter(item => item.reference_id != reference.reference_id);
    }

    function showSearchModal() {
        addModal(FrameworkSearchModal).then((res) => {
            addReference(res.framework, res.reference);
        })
    }

    async function showMouseOver(evt, reference_id) {
        if (mouseover && mouseover.reference_id == reference_id) return;

        let parts = reference_id.split(":");
        let framework_id = `${parts[0]}:${parts[1]}`;

        let framework = await db.get(framework_id);
        let control = await db.get(reference_id);

        let template = framework.autocomplete || "{{data['name']}}";

        let control_text = engine.parseAndRenderSync(template, {data: control});

        // get target
        let target = evt.target
        while (!target.classList.contains('control')) {
            target = target.parentNode;
        }

        mouseover ={
            text: control_text,
            reference_id: reference_id,
            top: target.offsetTop + target.clientHeight,
            left: target.offsetLeft
        };
    }

    function showReferenceModal(reference) {
        addModal(ReferenceModal, {
            reference
        }).catch(() => null)
    }

    $: frameworks = FrameworkReference.getList();
    $: loadFrameworkItems(currentFramework)

</script>

<div class="content tag_group">
    {#if value}
        {#each sortBy(value, ['framework']) as reference (reference.reference_id)}
            <div
                class="control"
            >
                <div class="tags has-addons">
                    <span class="tag is-dark">{reference.framework}</span>
                    <span
                        class="tag is-info is-clickable"
                        on:mouseover|stopPropagation={(evt) => showMouseOver(evt, reference.reference_id)}
                        on:focus|stopPropagation={(evt) => showMouseOver(evt, reference.reference_id)}
                        on:mouseout|stopPropagation={() => mouseover = false}
                        on:blur|stopPropagation={() => mouseover = false}

                        on:click={() => showReferenceModal(reference)}
                    >
                        {reference.control}
                    </span>
                    {#if !readOnly}
                        <span class="tag is-delete link" on:click|stopPropagation={() => removeReference(reference)}></span>
                    {/if}
                </div>
            </div>
        {/each}
    {/if}
    {#if mouseover}
        <div class="message is-info popover" style="top: {mouseover.top}px; left: {mouseover.left}px">
            <div class="message-body">
                {mouseover.text}
            </div>
        </div>
    {/if}
</div>

{#if $frameworks && !readOnly}
<div class="content">
    <form on:submit|stopPropagation|preventDefault={() => addReference(currentFramework, currentReference)}>
        <div class="field has-addons">
            <p class="control">
                <span class="select">
                    <select name="framework" bind:value={currentFramework}>
                        {#each $frameworks as framework (framework._id)}
                                <option value={framework}>{framework.name}</option>
                        {/each}
                    </select>
                </span>
            </p>
            <p class="control is-expanded">
                {#if frameworkItems}
                    <span class="select">
                        <select name="control" bind:value={currentReference}>
                            {#each frameworkItems as reference}
                                <option value={reference.value}>{reference.label}</option>
                            {/each}
                        </select>
                    </span>
                {/if}
            </p>
            <p class="control">
                <button class="button is-primary">
                    Add Reference
                </button>
            </p>
            <p class="control">
                <span class="button" on:click={showSearchModal}>
                    <span class="icon">
                        <Fa icon={faSearch} />
                    </span>
                </span>
            </p>
        </div>
    </form>
</div>
{/if}

<style>
    .select, .select select {
        width: 100%;
        position: relative;
    }


    .content.tag_group {
        position: relative;
    }

    .popover {
        position: absolute;
        max-width: 500px;
        z-index: 10000;
    }
</style>